import { Checkbox, FormControl, FormControlLabel, Grid, InputLabel, makeStyles, MenuItem, Paper, Select, Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React, { useGlobal } from 'reactn';
import MissingParameters from '../../components/Errori/MissingParameters';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { IMPRESA, PROFESSIONE } from '../../states/BudgetState';
import data from '../../json/tabelle.json';
import { IRAP_PercDataClass } from '../../types/types';
import { API_elaboraSchedaBudget } from '../../utils/functions';
import { SchedaBudgetInputProps } from './InformazioniCosti';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         // select: {
//         //     width: "10rem",
//         // },
//         // bottomControlLabel: {
//         //     verticalAlign: 'bottom',
//         //     marginLeft: theme.spacing(1),
//         // }
//     }),
// );

export default function IRAP(props: SchedaBudgetInputProps) {

    // const classes = useStyles();
    const gClasses = globalStyles();
    const [global] = useGlobal<IGlobalState>();
    const action = "changeImposteContributi";
    const { state } = props;

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }

    const handleChangeSelect = (e: any) => {
        handleChange(e);
        let { name, value } = e.target;
        API_elaboraSchedaBudget(props, global, name, value, action, true);
    }

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;
        props.handleChange(action, name, checked);
        API_elaboraSchedaBudget(props, global, name, checked, action, true);
    };

    const handleBlur = (e: any) => {
        API_elaboraSchedaBudget(props, global);
    }

    const IRAP = data.IRAP as IRAP_PercDataClass;

    var isImpresa = IMPRESA(state);
    var isProfessione = PROFESSIONE(state);

    return (
        <Paper className={gClasses.fullWidthPaper}>
            <Grid container>
                <SectionSubTitle text="IRAP"></SectionSubTitle>
                <Grid container>
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.F53_assenza_di_autonoma_organizzazione}
                                name='F53_assenza_di_autonoma_organizzazione'
                                id='F53_assenza_di_autonoma_organizzazione'
                                value={state.imposteContributi.F53_assenza_di_autonoma_organizzazione}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Assenza di autonoma organizzazione"
                    />
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="D55_aliquota">Aliquota</InputLabel>
                        <Select
                            className={gClasses.selectIForf}
                            value={state.imposteContributi.F55_aliquota}
                            onChange={handleChangeSelect}
                            inputProps={{ name: 'F55_aliquota', id: 'F55_aliquota' }}
                        >
                            <MenuItem value={0}>Non definito</MenuItem>
                            <MenuItem value={IRAP.perc_1}>{IRAP.perc_1}</MenuItem>
                            <MenuItem value={IRAP.perc_2}>{IRAP.perc_2}</MenuItem>
                            <MenuItem value={IRAP.perc_3}>{IRAP.perc_3}</MenuItem>
                            <MenuItem value={IRAP.perc_4}>{IRAP.perc_4}</MenuItem>
                            <MenuItem value={IRAP.perc_5}>{IRAP.perc_5}</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                {
                    isImpresa
                    ? <div>
                        <NumberField
                            name="E58_valore_della_produzione"
                            label="Valore della produzione"
                            value={state.imposteContributi.E58_valore_della_produzione}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                        <NumberField
                            name="H58_deduzioni"
                            label="Deduzioni"
                            value={state.imposteContributi.H58_deduzioni}
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                        />
                        <NumberField
                            name="E59_imponibile_irap"
                            label="Imponibile Irap"
                            value={state.imposteContributi.E59_imponibile_irap}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                        <NumberField
                            name="H59_irap"
                            label="Irap"
                            value={state.imposteContributi.H59_irap}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </div>
                    : isProfessione
                    ? <div>
                        <NumberField
                            name="E61_valore_della_produzione"
                            label="Valore della produzione"
                            value={state.imposteContributi.E61_valore_della_produzione}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                        <NumberField
                            name="H61_deduzioni"
                            label="Deduzioni"
                            value={state.imposteContributi.H61_deduzioni}
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                        />
                        <NumberField
                            name="E62_imponibile_irap"
                            label="Imponibile Irap"
                            value={state.imposteContributi.E62_imponibile_irap}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                        <NumberField
                            name="H62_irap"
                            label="Irap"
                            value={state.imposteContributi.H62_irap}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </div>
                    : <MissingParameters campo="Tipologia" pagina="COSTI DI AVVIO"></MissingParameters>
                }
            </Grid>
        </Paper>
    )
}